import React, { useState } from "react";
import MotorAccordWrapper from "./MotorAccord.style";
import { Accordion, AccordionTab } from "primereact/accordion";
import { withTranslation } from "react-i18next";
import man from "assets/images/icons/Vectorpersonal-logo.svg";
import PersonalDetailedValue from "../PersonalDetailValue/PersonalDetailValue";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "helpers/utils";

const MotorAccord = ({ customerDetails }) => {
  // const currentLanguageCode = props.i18n.language || "en";
  // const showRTL = currentLanguageCode === "ar";
  const handleAccordion = (bool) => {
    toggleAccordion(bool);
  };
  const [accordion, toggleAccordion] = useState(false);
  const { i18n } = useTranslation();
  const { businessLine } = useParams();

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF;
  else if (businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC;
  else if (businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID;
  else if (businessLine === BUSINESS_LINE_PATHS.CARTRUST)
    businessColor = BUSINESS_LINE_COLORS.CARTRUST;
  else if (businessLine === BUSINESS_LINE_PATHS.SYARAH) businessColor = BUSINESS_LINE_COLORS.SYARAH;
  else if(businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if(businessLine === BUSINESS_LINE_PATHS.ALNAGHI) businessColor = BUSINESS_LINE_COLORS.ALNAGHI;
  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.PETROMIN)
    businessColor = BUSINESS_LINE_COLORS.PETROMIN;

  const iconColorStyleObj = { color: businessColor };

  return (
    <MotorAccordWrapper>
      <div className="set-accord">
        <div className="reuse-accord">
          <Accordion
            onTabOpen={() => handleAccordion(true)}
            onTabClose={() => handleAccordion(false)}
          >
            <AccordionTab
              header={
                <React.Fragment>
                  <div className="flex-container p-2">
                    <React.Fragment>
                      <div className="header-flex">
                        <div className="header-Text">
                          <div className="head-icon">{<img src={man} alt="" />}</div>
                          <div className="welcome-text">
                            {<span>{i18n.t("PERSONAL_DETAIL.WELCOME")}</span>},{" "}
                            {i18n.language === "ar"
                              ? customerDetails?.araFirstName
                              : customerDetails?.engFirstName ?? "N/A"}
                          </div>
                        </div>
                        <div className="Icon-Div">
                          {" "}
                          {/* {props.i18n.t("PERSONAL_DETAIL.VIEWDETAILS")} */}
                          {accordion ? (
                            <i
                              className="pi pi-chevron-up accordianIcon up-acc"
                              style={iconColorStyleObj}
                            ></i>
                          ) : (
                            <i
                              className="pi pi-chevron-down accordianIcon down-acc"
                              style={iconColorStyleObj}
                            ></i>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  </div>
                </React.Fragment>
              }
            >
              <div className="inner-content">
                <PersonalDetailedValue {...{ customerDetails }} />
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
    </MotorAccordWrapper>
  );
};
export default withTranslation()(MotorAccord);
